module.exports = __webpack_public_path__ + "img/loader-black.6700fe81.svg";